import Training from '../../training';

/**
 * Create the action
 */

const { thunk, request, success, error } = Training.update((data, fetch) => {
  if (data?.synchDreams) {
    return fetch.post(`/dreams/training/sync/${data.trainingId}`, data);
  }

  // Prepare request
  const formData = new FormData();
  formData.append('_method', 'PUT');
  ['visibility', 'title', 'description', 'youtube', 'is_published'].map((key) =>
    data[key] !== undefined ? formData.append(key, data[key]) : null
  );

  return fetch.post(`/trainings/${data.trainingId}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
